/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.service
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: environment_booking.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as environment_booking_pb from './environment_booking_pb'; // proto import: "environment_booking.proto"


export class EnvironmentBookingServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetEnvironmentBooking = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.EnvironmentBookingService/GetEnvironmentBooking',
    grpcWeb.MethodType.UNARY,
    environment_booking_pb.GetEnvironmentBookingRequest,
    environment_booking_pb.GetEnvironmentBookingResponse,
    (request: environment_booking_pb.GetEnvironmentBookingRequest) => {
      return request.serializeBinary();
    },
    environment_booking_pb.GetEnvironmentBookingResponse.deserializeBinary
  );

  getEnvironmentBooking(
    request: environment_booking_pb.GetEnvironmentBookingRequest,
    metadata?: grpcWeb.Metadata | null): Promise<environment_booking_pb.GetEnvironmentBookingResponse>;

  getEnvironmentBooking(
    request: environment_booking_pb.GetEnvironmentBookingRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: environment_booking_pb.GetEnvironmentBookingResponse) => void): grpcWeb.ClientReadableStream<environment_booking_pb.GetEnvironmentBookingResponse>;

  getEnvironmentBooking(
    request: environment_booking_pb.GetEnvironmentBookingRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: environment_booking_pb.GetEnvironmentBookingResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.EnvironmentBookingService/GetEnvironmentBooking',
        request,
        metadata || {},
        this.methodDescriptorGetEnvironmentBooking,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.EnvironmentBookingService/GetEnvironmentBooking',
    request,
    metadata || {},
    this.methodDescriptorGetEnvironmentBooking);
  }

}

